import api from "./api";

export interface RestoreBackupResult {
  accepted: boolean;
  preRestoreBackup?: string;
  restoredDb?: string;
  savedUploadAs?: string;
}

export async function restoreDatabaseBackup(
  file: string,
  confirmationPhrase: string
): Promise<RestoreBackupResult> {
  const { data } = await api.post<RestoreBackupResult>("/backups/restore", {
    file,
    confirmation_phrase: confirmationPhrase,
  });
  return data;
}

/** Restaura o banco a partir de um arquivo .sql/.sql.gz enviado na hora. */
export async function restoreDatabaseFromUpload(
  file: File,
  confirmationPhrase: string
): Promise<RestoreBackupResult> {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("confirmation_phrase", confirmationPhrase);

  const { data } = await api.post<RestoreBackupResult>(
    "/backups/restore-upload",
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return data;
}
